export default __webpack_public_path__ + "engine/assets/HsuW4m4.mp4";